'use strict';

import angular from 'angular';
import './autorisations-recherche.routes';
import './autorisations-recherche.controller';
import './autorisations-recherche.css';

export default angular.module('observatoireApp.autorisationsRecherche', []);
